import { logger } from 'utils';
import $store from 'stores';

import { Element, Parents } from 'types';
import { NEWS, SYNC } from 'constants/popups';

const apply = () => {
  if (__DEV__ || __STAGING__) {
    window.__SHOW_POPUP = (name) => {
      if (!__STAGING__) {
        if (name === NEWS) {
          // eslint-disable-next-line
          const news = require('../../public/news.json')[0];
          $store.dispatch('popupShowWithData', {
            name,
            data: news,
          });
        }
      }

      if (name === SYNC) {
        $store.dispatch('popupShowWithData', {
          name,
          data: {
            timestamp: Date.now() - 10000,
            reseted: Date.now(),
            count: 56,
            onSuccess: () => $store.dispatch('popupHide', undefined),
          },
        });
        return;
      }

      $store.dispatch('popupShow', name as any);
    };

    window.__BIG_PROGRESS = (count = 150) => {
      const elements = Object.keys($store.getters.elements).slice(0, count);
      $store.state.library.library = elements;
    };

    window.__GAME_END = () => {
      const omit = 'frozen yogurt';
      const possible = $store.getters.elementsIds
        .map((id) => {
          const element = $store.getters.elementById(id) as Element;
          if (element.name === omit) return [];

          if (element.parents.length) {
            const [father, mother] = element.parents[0];
            const f = $store.getters.elementById(father);
            const m = $store.getters.elementById(mother);
            if (!f || !m) return [];

            return [f.id, m.id, Date.now()];
          }

          return [];
        });

      window.__DISABLE_STORAGE();
      localStorage.setItem('history', JSON.stringify(possible));
      window.location.reload();
    };

    window.__GAME_COMPLETION = () => {
      const possible: Parents[] = [];
      $store.getters.elementsIds
        .forEach((id) => $store.getters.elementById(id)!.parents
          .forEach((parents: Parents) => possible.push(parents)));

      const history = possible.map(([f, m]) => [f, m, Date.now()]);
      history.splice(-4, 2);

      window.__DISABLE_STORAGE();
      localStorage.setItem('history', JSON.stringify(history));
      window.location.reload();
    };

    window.__GAME_PROGRESS = (progress: number) => {
      const possible = $store.getters.elementsIds
        .map((id) => {
          const element = $store.getters.elementById(id) as Element;
          if (element.parents.length && !element.base && !element.prime) {
            const [father, mother] = element.parents[0];
            const f = $store.getters.elementById(father);
            const m = $store.getters.elementById(mother);
            if (!f || !m) return [];

            return [f.id, m.id, Date.now()];
          }

          return null;
        })
        .filter((entry) => entry !== null);

      const history = possible.slice(0, progress - $store.getters.prime.length);

      window.__DISABLE_STORAGE();
      localStorage.setItem('history', JSON.stringify(history));
      window.location.reload();
    };

    // log to console current commit data
    window.__COMMIT = () => {
      const t = new Date(__COMMIT__.date);
      const date = `${ t.getDate() }.${ t.getMonth() + 1 } ${ t.getHours() }:${ t.getMinutes() }`;
      return `${ __COMMIT__.branch }#${ __COMMIT__.short } - ${ date } => ${ __COMMIT__.message }`;
    };

    logger('git', window.__COMMIT());

    window.__POSSIBLE_CONNECTIONS = () => {
      const allPossible: Parents[] = [];
      $store.getters.elementsIds.forEach((id) =>
        $store.getters.elementById(id)!.parents.forEach((parents) => {
          if (!$store.getters.hasMixed(parents)) {
            allPossible.push(parents);
          }
        }),
      );
      const currentlyPossible: Parents[] = [];
      allPossible.forEach(([father, mother]) => {
        const f = $store.getters.elementById(father);
        const m = $store.getters.elementById(mother);
        if (!f || !m) return;
        if (!$store.getters.hasInProgress(father) || !$store.getters.hasInProgress(mother)) return;

        currentlyPossible.push([f.name, m.name]);
      });

      return currentlyPossible;
    };

    window.__POSSIBLE_ITEMS = () => $store.getters.elementsIds
      .filter((id) => !$store.getters.hasInProgress(id))
      .map((id) => $store.getters.elementById(id)!.name);

    window.__GAME_COMPLETION_ANIMATION = () => {
      const component = (document.querySelector('.animations') as any).__vue__;
      Object.defineProperty(component, 'shouldRenderCompletionAnimation', {
        value: true,
      });
      component.$forceUpdate();
      $store.dispatch('animationChange', 'GAME_COMPLETION');
    };

    window.__GAME_END_ANIMATION = () => {
      const component = (document.querySelector('.animations') as any).__vue__;
      Object.defineProperty(component, 'shouldRenderEndAnimation', {
        value: true,
      });
      component.$forceUpdate();
      $store.dispatch('animationChange', 'GAME_END');
    };
  }
};

apply();
